import React, {useState, useEffect} from 'react'
// Style
import './pckdt.style.css'
// APIs
import { NhealthAction } from '../../_actions/action.api'
import { Base_API } from '../../_actions/matcher'
// Icons
import CrossIcon from '../../assets/images/icons/cross.png'
import { useParams } from 'react-router-dom'
import { DecryptedOBJ } from '../../utils/Encryption'

function NH_Services_Detail(props) {
    const { ref, packID } = useParams(); 

    const [packSelected, setPackSelected] = useState([]);
    const [quantity, setQuantity] = useState(1);
    const [loading, setLoading] = useState(true);
    const [campaignData ,setCampaignData] = useState(null);
    const [memberData, setMemberData] = useState(null);
    const [productSelected, setProductSelected] = useState(null);
    const [cartList, setCartList] = useState(null);
    const [memberCode, setMemberCode] = useState(null);
    const [saveCartStatus, setSaveCartStatus] = useState('add'); // add or update
    const [currentCart, setCurrentCart] = useState(null);
    // Error
    const [errorMsg, setErrorMsg] = useState('');
    const [errorStatus, setErrorStatus] = useState(false); 
    // Search (Params)

    useEffect(() => {
        dataInit();
    },[])

    const dataInit = async() => {
        await RefCampaignInit();
        let packageData = await PackageByIdInit();
        let campaignData = await campaignInit();
        let mem_id = await checkUserInit();
        await calCartInit(campaignData,mem_id, packageData);
        handleLoader('inactive');
    }

    const calCartInit = (campaignData, membercode, packageData) => {
        return new Promise(async resolve => {
            NhealthAction.CalCart(campaignData.id, 0, membercode)
            .then(res => {
                // console.log('Cart Data: ', res);
                if(res.isSuccess === true)
                {
                    setCartList(res.cart);
                    checkAddOrUpdate(res.cart, packageData);
                }
                resolve();
            })
        })
    }

    const checkAddOrUpdate = (cartData, packageData) => {
        let currentCart = cartData.filter(item => item.SKU === packageData.code);
        // console.log(cartData);
        if(currentCart.length > 0)
        {
            setSaveCartStatus('update');
            setCurrentCart(currentCart[0]);
            setQuantity(currentCart[0].totalAmount);
        }else
        {
            setSaveCartStatus('add');
        }
    }

    const RefCampaignInit = () => {
        return new Promise(async resolve => {
            if(ref !== undefined && ref !== null)
            {
                resolve();
            }
        })
    }

    const checkUserInit = () => {
        return new Promise(async resolve => {
            let line_profile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            if(line_profile !== null)
            {
                NhealthAction.GetMember(line_profile.user_id)
                .then(res => {
                    if(res.isSuccess === true)
                    {
                        setMemberData(res.member);
                        setMemberCode(res.member.membercode);
                        resolve(res.member.membercode);
                    }else
                    {
                        setMemberCode(line_profile.user_id);
                        resolve(line_profile.user_id); 
                    }
                })
            }else
            {
                onBack(); // back to packages page.
            }
        })
    }

    const campaignInit = () => {
        return new Promise(async resolve => {
            NhealthAction.GetCampaignProductsOnline().then(data => {
                // console.log('Campaign Product Online: ', data);
                setCampaignData(data.campaign);
                resolve(data.campaign);
            })
        })
    }

    const PackageByIdInit = () => {
        return new Promise(async resolve => {
            NhealthAction.GetProductOnlineByID(packID)
            .then(res => {
                // console.log('Package By ID: ', res);
                if(res.code !== null && res.isSuccess !== false)
                {
                    setPackSelected(res);
                    resolve(res);
                }else
                {
                    if(res.errMessage === "authen expired !." || String(res.errMessage).indexOf('authen expired') > 0)
                    {
                        window.localStorage.clear();
                        onBack();
                    }
                }
            })
        })
    }

    const handleLoader = (status) => {
        if(status === 'inactive')
        {
            setLoading(false);
        }else
        {
            setLoading(true);
        }
    }

    const increaseQuantity = () => {
        setQuantity(quantity+1)
    }
    const decreaseQuantity = () => {
        if(quantity !== 1)
        {
            setQuantity(quantity-1)
        }else return
    }

    const onSelectVariant = async(e, product, code) => {
        // console.log('Selected Data: ', product);
        setProductSelected(product); 

        document.querySelectorAll(`.pkdt-pdvrt-item`).forEach(element => {
            element.classList.remove('error')
        }) 

        setErrorMsg('');
        setErrorStatus(false);

        await borderInactive();
        borderActive(code);
    }

    const borderActive = (code) => {
        let borderElem = document.querySelector(`.pkdt-pdvrt-item-${code}`);
        borderElem.classList.add('active');
    }

    const borderInactive = () => {
        return new Promise(async resolve => {
            let borderElem = document.querySelectorAll(`.pkdt-pdvrt-item`);
            borderElem.forEach((element, i) => {
                element.classList.remove('active');
                if(i+1 === borderElem.length)
                {
                    resolve();
                }
            })

        })
    }

    const handleAlert = (msg) => {
        setErrorStatus(true);
        setErrorMsg(msg)

        // style error border item
        document.querySelectorAll(`.pkdt-pdvrt-item`).forEach(element => {
            element.classList.add('error')
        })
    } 

    const onBack = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/nh-services/${ref}`;    
    }

    const pDetail = (
        <span dangerouslySetInnerHTML={{__html: packSelected.detail}}></span> 
    )

    const handleSubmitOrder = async() => {
        if(saveCartStatus === 'add')
        {
            let reqData = {
                campaign: campaignData.id,
                _refcampaign: ref,
                membercode: memberCode,
                SKU: packSelected.code,
                itemSKU: packSelected.code,
                totalAmount: quantity
            }
            // console.log('Req Data: ', reqData);
            NhealthAction.AddCart(reqData) 
            .then(res => {
                if(res.isSuccess === true)    
                {
                    onBack();
                }
            });
        }
        if(saveCartStatus === 'update')
        {
            let reqData = {
                cartid: currentCart.cartid,
                totalAmount: quantity,
            }
            // console.log('Req Data: ', reqData);
            NhealthAction.UpdateCart(reqData) 
            .then(res => {
                if(res.isSuccess === true)    
                {
                    onBack();
                }
            });
        }
    }

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <div className="pkdtpg-container">
                <div className="pkdt-wrap">
                    {/* header */}
                    <div className="pkdt-head_wrap">
                    {/* package name */}
                    <h1 className="pkdt-packname">{packSelected.pack_type_th} {packSelected.pack_type_en}</h1>
                    {/* right */}
                    <div className="pkdt-head_right">
                        <img    
                            src={CrossIcon} 
                            onClick={onBack}
                        />
                        {/* <i 
                            className="bi bi-chevron-down"
                            onClick={() => {
                                // setOpenDetail(false)
                                // document.querySelector('body').style.overflow = 'scroll';
                            }}
                        >
                        </i> */}
                    </div>
                    </div>
    
                    {/* promotion message */}
                    {/* <p className="pkdt-promotion">
                        ซื้อ 2 แพ็กเกจ ขึ้นไป ลดเหลือ ฿ 350 
                    </p> */}
    
                    {/* price */}
                    <div className="pkdt-price">
                        {/* flash deal price */}
                        <h2>฿ {Number(packSelected.flashdeal_price).toLocaleString('th')}</h2>
                        {/* default price */}
                        {packSelected.flashdeal_price !== packSelected.price &&
                            <span>฿ {Number(packSelected.price).toLocaleString('th')}</span>
                        }
                    </div>

                    {/* button increase & decrease */}
                    <div className="pkdt-button_add">
                        {/* decrease */}
                        <button
                            onClick={decreaseQuantity}
                        >-</button>
                        {/* quantity */}
                        <span>{quantity}</span>
                        {/* increase */}
                        <button
                            onClick={increaseQuantity}
                        >+</button>
                    </div>
    
                    {/* button submit */}
                    <button 
                        className="pkdt-submit_btn"
                        onClick={handleSubmitOrder}
                    >
                        สั่งซื้อ
                    </button>
                    {/* package description */}
                    <ul className="pkdt-desc">
                        <p>รายละเอียด</p>
                        {packSelected.pack_list !== undefined && packSelected.pack_list.map((order, i) => 
                            <li key={i}><span>•</span> <span>{order.pack_name_th}</span></li>
                        )}
                    </ul>
                    <div className="pkdt-desc-api">
                        {pDetail}
                    </div>
    
                    {/* policy order */}
                    {/* <ul className="pkdt-policy_order">
                        <span className="policy-title">เงื่อนไขการใช้สั่งซื้อ</span>
                        <li>• สามารถซื้อแพ็กเกจและชำระเงินได้ภายในวันที่ 5-12 ส.ค. 65 เท่านั้น</li>
                        <li>• สามารถรับบริการได้ตั้งแต่วันที่ 8 ส.ค. - 30 ก.ย.65 </li>
                        <li>• สามารถรับบริการได้ที่ Lab Center N Health ทุกสาขา</li>
                    </ul> */}
    
                    {/* policy service */}
                    {/* <ul className="pkdt-policy_service">
                        <span className="policy-title">เงื่อนไขการใช้บริการ</span>
                        <li><span>1. </span><p>เพื่อให้ท่านได้รับบริการที่สะดวกรวดเร็ว กรุณานัดหมายล่วงหน้า 1 วัน</p></li>
                        <li><span>2. </span><p>กรณีที่ท่านไม่ได้ทำการนัดหมายล่วงหน้าเจ้าหน้าที่ขอตรวจสอบข้อมูล การชำระเงินโดยท่านต้องแสดงหลักฐานใบเสร็จรับเงินกับเจ้าหน้าที่</p></li>
                        <li><span>3. </span><p>หากท่านไม่ได้เป็นผู้เข้ารับการตรวจสุขภาพเอง กรุณาแจ้งข้อมูลเพิ่มเติมกับแอดมินช่องทาง Line : @nhealth</p></li>
                        <li><span>4. </span><p>แพ็กเกจที่ท่านได้สั่งซื้อและชำระเงินแล้ว ไม่สามารถแลก เปลี่ยน หรือคืนเป็นเงินสดได้</p></li>
                        <li><span>5. </span><p>ทางบริษัทขอสงวนสิทธิการเข้ารับบริการหากท่านไม่ปฏิบัติตามเงื่อนไขที่บริษัทกำหนด</p></li>
                    </ul> */}
    
                    {/* contact us */}
                    <div className="pkdt-contact_us">
                        <h3>สอบถามรายละเอียดและนัดหมายเพื่อรับบริการได้ที่</h3>
                        <span>N Health Customer service 02-7624000 กด1 หรือ กด9</span>
                        <span>Line: @nhealth</span>
                    </div>
    
                </div>      
            </div>
        )
    }

}

export default NH_Services_Detail